import moment from "moment";
import { formatCurrency } from "../../../../services/format";

import { FormItemType } from "../../../UI/view/component-map";
import { DataSource } from "../../../UI/view/data-source";
import { FormView } from "../../../UI/view/form-view";
import { FilterType, ListView, ListViewColumnType, initListView } from "../../../UI/view/list-view";
import { initView } from "../../../UI/view/view";
import { BillingGasRentalListView } from "./gasrental-invoice-list";
import { months } from "../../../../services/date-helpers";
import { billingPermissions } from "../billing-datasource";
import { InsertBilling, InvoiceAllGasRentals, getGasRental, getGasRentalsMTD, getGasRentalsUnbilled } from "../../../../services/requests/billing/gas-rental-billing-requests";

export const gasrentalordersDS = {
  name: 'gasrentalbill',
  pk: 'pk',
  request: getGasRentalsUnbilled,
  updateRequest: InsertBilling,
  entityRequest: getGasRental,
  skipLocalUpdate: true,
} as DataSource;
export const gasrentalMTDDS = {
  name: 'gasrentalmtd',
  pk: 'pk',
  request: getGasRentalsMTD,
  updateRequest: InsertBilling,
  entityRequest: getGasRental,
  skipLocalUpdate: true,
} as DataSource;

///create function that takes the first 1000 items in an array and returns them


export const gasRentalOrdersList = {
  autoCheckAll: true,
  disableSelection: true,
  toolbar: [
    {
      type: FormItemType.button,
      label: 'Invoice All Unbilled Rentals',
      handler: async ({ getValues, confirm, loadEntity }) => {
        const proceed = await confirm('Are you sure you want to invoice all Unbilled Rentals?');
        if (proceed) {
          const myVals = getValues();
          console.log(myVals)
          try {
            await InvoiceAllGasRentals();
            await confirm('Rentals invoiced Successfully', true);
            loadEntity();
          } catch {
            await confirm('There was an error invoicing rentals', true)
          }

        }
      }
    },
  ],
  columns: [
    {
      type: ListViewColumnType.icon,
      id: 'trafficStatus',
      accessor: ({ invoiceYear, invoiceMonth }) => moment().year() == invoiceYear && moment().month() + 1 == invoiceMonth ? 'clock-history' : 'currency-dollar',
      tooltip: ({ invoiceYear, invoiceMonth }) => moment().year() == invoiceYear && moment().month() + 1 == invoiceMonth ? 'MTD' : 'Unbilled',
    },
    {
      Header: 'Customer Name',
      accessor: 'customerName',
      type: ListViewColumnType.linkEdit,
      linkPath: ({ val, row }) => '/billing/gasrentalinvoice/' + row.original.pk
    },
/*     {
      Header: 'CST',
      accessor: 'gasCustomerId'
    }, */
    {
      Header: 'Year',
      accessor: 'invoiceYear'
    },
    {
      Header: 'Month',
      id: 'invoiceMonth',
      accessor: ({invoiceMonth}) => months[invoiceMonth]
    },
    {
      Header: '	Number of Bookings Unbilled For Month',
      accessor: 'counter'
    },
    {
      Header: 'Total Amount ($)',
      accessor: 'total',
      Cell: ({ row: { original: { total } } }) => formatCurrency(total),
    },
/*     {
      Header: 'Order Number',
      accessor: 'orderNumber',
      hidden: true
    }, */
    {
      Header: 'Priority',
      id: 'priority',
      defaultSort: true,
      defaultSortDirection: 'desc',
      accessor: ({ invoiceYear, invoiceMonth }) => {
        console.log(moment().year())
        console.log(moment().month())
        return moment().year() == invoiceYear && moment().month() + 1 == invoiceMonth ? 2 : 1;
      },
      hidden: true 
    },
    {
      Header: 'RecordType',
      id: 'recordType',
      accessor: ({ invoiceYear, invoiceMonth }) => moment().year() == invoiceYear && moment().month() + 1 == invoiceMonth ? 'MTD' : 'Unbilled',
      hidden: true
    },
/*     {
      Header: 'Free Days',
      accessor: 'freeDays',
      hidden: true
    }, */
  ]
} as ListView;

export const GasRentalsListView = initListView(gasRentalOrdersList, gasrentalordersDS);
export const GasRentalsListViewMTD = initListView(gasRentalOrdersList, gasrentalMTDDS);

export const GasRentalsListPage = initView({
  form: {
    pageHeader: 'Gas Rental Billing',
    permissions: billingPermissions,
    breadcrumbs: [
      {
        name: 'Gas Rental Billing',
        icon: 'currency-dollar',
        to: '/billing/gas',
      },
    ],
    items: [
      {
        type: FormItemType.tab,
        items: [
          {
            label: 'Unbilled Rentals',
            mountOnEnter: false,
            badgeCounter: (state) => {
              return state.gasrentalbill?.data?.length;
            },
            items: [
              {
                items: [
                  {
                    type: FormItemType.customComponent,
                    component: GasRentalsListView,
                    name: 'unbilledList'
                  }
                ]
              }
            ]
          },
          {
            label: 'Invoices',
            mountOnEnter: false,
            badgeCounter: (state) => {
              let count = state.gasRB?.data?.filter(x => [0, 9].includes(x.status) && !x.jdebypassed).length;
              if(count == 100) count = `${count}+`;
              return count;
            },
            items: [
              {
                items: [
                  {
                    type: FormItemType.customComponent,
                    component: BillingGasRentalListView,
                    name: 'gasRentalBillingList'
                  }
                ]
              }
            ]
          },
          {
            label: 'MTD Rentals',
            mountOnEnter: true,
     /*        badgeCounter: (state) => {
              return state.gasrentalmtd?.data?.length;
            }, */
            items: [
              {
                items: [
                  {
                    type: FormItemType.customComponent,
                    component: GasRentalsListViewMTD,
                    name: 'mtdList'
                  }
                ]
              }
            ]
          },
        ]
      }
    ]
  } as FormView, dataSource: gasrentalordersDS
});
